import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useSlackSubscriptions(tenant: number) {
  return useQuery<string[]>({
    queryKey: ['slack-subscriptions', tenant],
    queryFn: async () => {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/slack/subscriptions`
      );

      return data?.channels || [];
    },
    retry: false,
  });
}
